import ViewsCatalog from '@/views/catalog/ViewsCatalog.vue';

import {home} from '@/router/breadcrumbs';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/catalog',
        name: 'catalog',
        component: ViewsCatalog,
        meta: {
            requiresAuth: true,
            breadcrumbs: [home, {text: 'catalog'}],
            permissions: [PERMISSIONS.EMPLOYEE]
        }
    }
] as RouteRecordRaw[]
